exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "player-merge .button-panel {\n  text-align: center; }\n  player-merge .button-panel button {\n    width: auto; }\n\nplayer-merge .ui-growl {\n  z-index: 1035 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/admin-module/player-merge/player-merge.component.scss
// module id = ../../../../../src/app/admin-module/player-merge/player-merge.component.scss
// module chunks = main